import { render, staticRenderFns } from "./mt-dy-sku-list.vue?vue&type=template&id=bb8c127c"
import script from "./mt-dy-sku-list.vue?vue&type=script&lang=js"
export * from "./mt-dy-sku-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports